
export const MimeType: MimeType = {
    Json: { type: "application/json", ext: "json", stringify: true },
    Pdf: { type: "application/pdf", ext: "pdf" },
    Xml: { type: "application/xml", ext: "xml" },
    Csv: { type: "application/csv", ext: "csv" },
    DocX: { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", ext: "docx"},
    XlsX: { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", ext: "xlsx" },
    Html: { type: "application/html", ext: "html"}
}

type MimeType = {
    [key in MimeTypeKey]: IMimeTypeObj
}

type MimeTypeKey = "Json" | "Pdf" | "Xml" | "Csv" | "DocX" | "XlsX" | "Html";

interface IMimeTypeObj {
    type: string;
    ext: string;
    stringify?: boolean
}

export const fileTypeToMimeType = (filetype: string): IMimeTypeObj => {
    switch ((filetype || "").toLowerCase()) {
        case "json":
            return MimeType.Json;
        case "xml":
            return MimeType.Xml;
        case "csv":
            return MimeType.Csv;
        case "docx":
            return MimeType.DocX;
        case "xlsx":
            return MimeType.XlsX;
        case "html":
            return MimeType.Html;
        case "doc":
            return MimeType.DocX;
        case "xls":
            return MimeType.XlsX;	
		case "pdf":
			return MimeType.Pdf;		
        default:
            return MimeType.XlsX;
    }
}

export const showFile = (blob: any, filename: string, MimeType: IMimeTypeObj, anchorElemId: string = null) => {     
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should   
    let _blob = null;

    if (!MimeType.stringify)
        _blob = base64ToArrayBuffer(blob)
    else 
        _blob = blob;

    const newBlob = new Blob([_blob], {type: MimeType.type});

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    const navigator: any = window.navigator;
    if (navigator && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(newBlob);
        return;
    } 

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    const download = `${filename}.${MimeType.ext}`;

    if (anchorElemId) {
        const anchorElem = document.getElementById(anchorElemId);
        anchorElem.setAttribute("href", data);
        anchorElem.setAttribute("download", download)
        anchorElem.click();
    } else {
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = data;
        link.download = download;
        link.click();
    }

    setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 1);
}    

const base64ToArrayBuffer = (data) => {
    let binaryString = window.atob(data);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}